import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Colors, IconButton } from 'library';
import { styled } from '@mui/material';
import { Close, Redeem } from '@mui/icons-material';
import { Banner, useBannerSlot } from 'parent-portal/navigation';
import { ReferralModal } from 'parent-portal/navigation/ReferralModal';

export function ReferralBanner({ small, setShowRefer }: { small: boolean; setShowRefer: (show: boolean) => void }) {
    const [open, setOpen] = useState<boolean>(false);
    const slot = useBannerSlot();

    const bannerNode = (
        <Banner
            variant="accent"
            action={
                <IconButton
                    icon={Close}
                    backgroundColor="transparent"
                    color={Colors.white}
                    style={{ boxShadow: 'none' }}
                    onClick={() => setShowRefer(false)}
                />
            }
        >
            <Content>
                <Redeem style={{ color: Colors.white, marginRight: 6 }} />
                <strong>Loving Tandem?</strong>
                <ReferLink onClick={() => setOpen(true)}>Refer a center and you both get $50!</ReferLink>
            </Content>
        </Banner>
    );

    return (
        <>
            {slot && ReactDOM.createPortal(bannerNode, slot)}
            <ReferralModal isOpen={open} onClose={() => setOpen(false)} small={small} />
        </>
    );
}

const Content = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
});

const ReferLink = styled('button')({
    background: 'none',
    border: 'none',
    padding: 0,
    color: Colors.white,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: 'inherit',
    '&:hover': { color: Colors.lightGrey },
});
